import { render, staticRenderFns } from "./AssociationCard.vue?vue&type=template&id=59d37624&scoped=true"
import script from "./AssociationCard.vue?vue&type=script&lang=js"
export * from "./AssociationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d37624",
  null
  
)

export default component.exports